import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container q-mt-sm"
}
const _hoisted_5 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_6 = {
  key: 1,
  class: "inner_container"
}
const _hoisted_7 = { class: "field-group q-mt-sm" }
const _hoisted_8 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_9 = {
  key: 0,
  class: "bold-name mr-xs"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "search-sticky-container q-pa-xs bg-white" }
const _hoisted_12 = { class: "q-pa-xs bg-white" }
const _hoisted_13 = { class: "text-grey q-pa-md text-center" }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { class: "search-sticky-container q-pa-xs bg-white" }
const _hoisted_16 = { class: "q-pa-xs bg-white" }
const _hoisted_17 = { class: "text-grey q-pa-md text-center" }
const _hoisted_18 = { class: "main-display-container" }
const _hoisted_19 = { class: "field-group" }
const _hoisted_20 = { class: "field-group__row" }
const _hoisted_21 = { class: "bold-name" }
const _hoisted_22 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_23 = { class: "field-group" }
const _hoisted_24 = { class: "field-group__row" }
const _hoisted_25 = { class: "bold-name" }
const _hoisted_26 = { class: "row no-wrap justify-end q-mt-sm q-mr-md" }
const _hoisted_27 = {
  key: 0,
  class: "field-group"
}
const _hoisted_28 = { class: "bold-name flex items-center" }
const _hoisted_29 = { class: "file-list" }
const _hoisted_30 = { class: "field-group" }
const _hoisted_31 = { class: "bold-name flex items-center" }
const _hoisted_32 = { class: "file-button q-ml-md" }
const _hoisted_33 = { class: "file-list" }
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = { class: "pending" }
const _hoisted_36 = { class: "field-group q-mt-sm" }
const _hoisted_37 = { class: "field-group__row" }
const _hoisted_38 = { class: "field-group__col" }
const _hoisted_39 = {
  class: "flex items-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_40 = { class: "bold-name" }
const _hoisted_41 = {
  key: 0,
  class: "movement-comment-existing q-mb-xs"
}
const _hoisted_42 = { class: "field-group__colsmall" }
const _hoisted_43 = { class: "summary" }
const _hoisted_44 = {
  key: 0,
  class: "summary__label"
}
const _hoisted_45 = { class: "summary__label" }
const _hoisted_46 = {
  key: 1,
  class: "summary__hint"
}
const _hoisted_47 = { class: "summary" }
const _hoisted_48 = {
  key: 1,
  class: "field-group q-mt-sm"
}
const _hoisted_49 = { class: "bold-name" }
const _hoisted_50 = { class: "row no-wrap items-start" }
const _hoisted_51 = {
  class: "row no-wrap items-start",
  style: {"overflow-x":"auto"}
}
const _hoisted_52 = { style: {"padding-top":"6px"} }
const _hoisted_53 = { ref: "triggerEl" }
const _hoisted_54 = {
  key: 0,
  class: "dialog-table",
  style: {"margin-top":"-3px"}
}
const _hoisted_55 = {
  key: 2,
  class: "field-group"
}
const _hoisted_56 = { class: "bold-name" }
const _hoisted_57 = {
  key: 0,
  class: "field-group q-mb-md"
}
const _hoisted_58 = { class: "row no-wrap justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_project_row = _resolveComponent("project-row")!
  const _component_movement_create_component = _resolveComponent("movement-create-component", true)!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_payment_create_component = _resolveComponent("payment-create-component")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_connections_table_html = _resolveComponent("connections-table-html")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_item_addition_component = _resolveComponent("item-addition-component")!
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_positions_table_html = _resolveComponent("positions-table-html")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    tabindex: "0",
    ref: "cardRootRef",
    class: "inhdialog-container",
    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.$refs.acc_menu && _ctx.$refs.acc_menu.hide())),
    onKeydown: _withKeys(_withModifiers(_ctx.onEscKeydown, ["prevent"]), ["esc"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.isEditMode ? _ctx.$t('information_about')+" " : _ctx.$t('adding')+" ") + " " + _toDisplayString(_ctx.isEditMode
            ? (_ctx.isIncome ? _ctx.$t('in_receipt_loc') : _ctx.isExpense ? _ctx.$t('in_expenditure_loc') : _ctx.$t('in_transfer_loc')) +
              " " +
              _ctx.theModel.VendorCode
            : _ctx.isIncome
            ? _ctx.$t('of_receipt')
            : _ctx.isExpense
            ? _ctx.$t('of_expenditure')
            : _ctx.$t('of_transfer')), 1),
        _createVNode(_component_app_icon, {
          name: "close",
          width: "18px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          title: _ctx.$t('close_esc_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "field-group"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "skeleton skeleton-title" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["skeleton skeleton-text", {
                'skeleton-text-short': n % 3 === 0,
                'skeleton-text-medium': n % 3 === 1,
              }])
                    }, null, 2)
                  ])
                ])
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isExpense || _ctx.isTransfer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('from')) + ": ", 1))
                    : _createCommentVNode("", true),
                  ((_ctx.isExpense || _ctx.isTransfer) && _ctx.isEditMode && !_ctx.isEditing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.storageOptions.find((el) => el.value === _ctx.theModel.from)?.label), 1))
                    : (
                (_ctx.isExpense || _ctx.isTransfer) && (!_ctx.isEditMode || _ctx.isEditing)
              )
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 2,
                          flat: "",
                          modelValue: _ctx.theModel.from,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.theModel.from) = $event)),
                          style: {"min-width":"150px"},
                          class: "thin-input q-mr-xs",
                          "dropdown-icon": "expand_more",
                          "fill-input": "",
                          "bottom-slots": false,
                          dense: "",
                          outlined: "",
                          "input-debounce": "500",
                          "emit-value": "",
                          "map-options": "",
                          options: _ctx.storageOptions,
                          ref: "from_select",
                          onPopupHide: _cache[5] || (_cache[5] = 
                () => {
                  _ctx.searchText = '';
                  _ctx.confirmStorage();
                }
              ),
                          "popup-content-class": "my-sticky-select-menu"
                        }, {
                          "before-options": _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_q_input, {
                                outlined: "",
                                dense: "",
                                ref: "from_search_input",
                                color: "white",
                                class: "thin-input q-my-auto",
                                modelValue: _ctx.searchText,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                                "hide-bottom-space": "",
                                clearable: "",
                                autofocus: "",
                                "clear-icon": _ctx.clearIconName,
                                placeholder: _ctx.$t('search_label'),
                                debounce: "300",
                                onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = ''))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "search",
                                    color: "accent"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "clear-icon", "placeholder"])
                            ])
                          ]),
                          "no-option": _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_q_input, {
                                outlined: "",
                                dense: "",
                                ref: "from_search_input",
                                color: "white",
                                class: "thin-input q-my-auto",
                                modelValue: _ctx.searchText,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event)),
                                "hide-bottom-space": "",
                                clearable: "",
                                autofocus: "",
                                "clear-icon": _ctx.clearIconName,
                                placeholder: _ctx.$t('search_label'),
                                debounce: "300",
                                onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchText = ''))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "search",
                                    color: "accent"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "clear-icon", "placeholder"]),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('nothing_found')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                  (!_ctx.isStorageConfirmed)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 3,
                        "no-caps": "",
                        label: _ctx.$t('select_warehouse'),
                        flat: "",
                        onClick: _ctx.confirmStorage
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.isIncome || _ctx.isTransfer)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "bold-name mr-xs"
                      }, _toDisplayString(_ctx.$t('to_upper')) + ": ", 513)), [
                        [_vShow, _ctx.isStorageConfirmed]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.isIncome || _ctx.isTransfer) && _ctx.isEditMode && !_ctx.isEditing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.storageOptions.find((el) => el.value === _ctx.theModel.to)?.label), 1))
                    : _createCommentVNode("", true),
                  ((_ctx.isIncome || _ctx.isTransfer) && (!_ctx.isEditMode || _ctx.isEditing))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_select, {
                        key: 6,
                        flat: "",
                        modelValue: _ctx.theModel.to,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.theModel.to) = $event)),
                        class: "thin-input",
                        "dropdown-icon": "expand_more",
                        "fill-input": "",
                        "bottom-slots": false,
                        dense: "",
                        outlined: "",
                        "input-debounce": "500",
                        "emit-value": "",
                        "map-options": "",
                        ref: "to_select",
                        style: {"min-width":"150px"},
                        options: _ctx.storageOptions,
                        onPopupHide: _cache[11] || (_cache[11] = 
                () => {
                  _ctx.searchText = '';
                }
              ),
                        "popup-content-class": "my-sticky-select-menu"
                      }, {
                        "before-options": _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_q_input, {
                              outlined: "",
                              dense: "",
                              ref: "from_search_input",
                              color: "white",
                              class: "thin-input q-my-auto",
                              modelValue: _ctx.searchText,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchText) = $event)),
                              autofocus: "",
                              "hide-bottom-space": "",
                              clearable: "",
                              "clear-icon": _ctx.clearIconName,
                              placeholder: _ctx.$t('search_label'),
                              debounce: "300",
                              onClear: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchText = ''))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "search",
                                  color: "accent"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "clear-icon", "placeholder"])
                          ])
                        ]),
                        "no-option": _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_q_input, {
                              outlined: "",
                              dense: "",
                              ref: "from_search_input",
                              color: "white",
                              class: "thin-input q-my-auto",
                              modelValue: _ctx.searchText,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchText) = $event)),
                              "hide-bottom-space": "",
                              clearable: "",
                              autofocus: "",
                              "clear-icon": _ctx.clearIconName,
                              placeholder: _ctx.$t('search_label'),
                              debounce: "300",
                              onClear: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchText = ''))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "search",
                                  color: "accent"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "clear-icon", "placeholder"]),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('nothing_found')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])), [
                        [_vShow, _ctx.isStorageConfirmed]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.isIncome ? _ctx.$t('projects_label') : _ctx.$t('project_label')), 1),
                    _withDirectives(_createVNode(_component_q_btn, {
                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.projectMenuVisible = !_ctx.projectMenuVisible), ["stop"])),
                      ref: "projectMenuTrigger",
                      dense: "",
                      flat: "",
                      size: "md",
                      class: "q-pa-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_app_icon, {
                          name: "plus",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.existingMovementId ? (_ctx.CanWrite && (_ctx.isIncome || !_ctx.theModel.projects.length)) : ((!_ctx.isEditMode || _ctx.isEditing) && (_ctx.isIncome || !_ctx.theModel.projects.length))]
                    ]),
                    _createVNode(_component_selector_popup, {
                      visible: _ctx.projectMenuVisible,
                      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.projectMenuVisible) = $event)),
                      "trigger-el": _ctx.$refs.projectMenuTrigger,
                      "default-width": 300
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_aux_selector, {
                          "model-type": 19,
                          "input-index": 0,
                          "allow-multiple": false,
                          "model-value": _ctx.theModel.projects,
                          "limit-height-to-container": true,
                          "onUpdate:modelValue": _ctx.onProjectsUpdate,
                          onSelectorClosed: _cache[13] || (_cache[13] = ($event: any) => (_ctx.projectMenuVisible = false))
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["visible", "trigger-el"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel.projects, (p, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: p.id
                    }, [
                      _createVNode(_component_project_row, {
                        class: "q-mb-xs",
                        el: p,
                        "hide-remove-btn": _ctx.existingMovementId ? !_ctx.CanWrite : (_ctx.isEditMode && !_ctx.isEditing),
                        onDetach: ($event: any) => (_ctx.removeProject(idx))
                      }, null, 8, ["el", "hide-remove-btn", "onDetach"])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.isTransfer && _ctx.isEditMode && _ctx.theModel.projects?.length && !_ctx.readOnly)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          "no-caps": "",
                          label: _ctx.$t('create_expenditure'),
                          flat: "",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.returnFromProject(1)))
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.isTransfer && _ctx.isEditMode && _ctx.theModel.projects?.length && !_ctx.readOnly)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          "no-caps": "",
                          label: _ctx.$t('create_transfer'),
                          flat: "",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.returnFromProject(2)))
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_q_dialog, {
                    modelValue: _ctx.createMovementMode,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.createMovementMode) = $event)),
                    persistent: "",
                    "no-shake": "",
                    "full-width": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_movement_create_component, {
                        "create-type": _ctx.createMoveType,
                        onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createMovementMode = false)),
                        "source-model": _ctx.returnReceiptModel
                      }, null, 8, ["create-type", "source-model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('bills')), 1),
                    _withDirectives(_createVNode(_component_q_btn, {
                      onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                      dense: "",
                      flat: "",
                      size: "md",
                      class: "q-pa-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_app_icon, {
                          name: "plus",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        }),
                        _createVNode(_component_q_menu, {
                          "max-height": "1300px",
                          ref: "acc_menu",
                          anchor: "center right",
                          self: "center left",
                          style: {"overflow":"hidden"},
                          onKeydown: _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.acc_menu && _ctx.$refs.acc_menu.hide()), ["exact"]), ["esc"])),
                          persistent: "",
                          "no-shake": ""
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isIncome)
                              ? (_openBlock(), _createBlock(_component_q_tabs, {
                                  key: 0,
                                  modelValue: _ctx.accounts_tab,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.accounts_tab) = $event)),
                                  dense: "",
                                  class: "text-grey bg-white",
                                  "active-color": "dark",
                                  "indicator-color": "accent",
                                  align: "justify"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tab, {
                                      name: "account_selector",
                                      "no-caps": "",
                                      label: _ctx.$t('invoices_payments_unattached')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_q_tab, {
                                      name: "new_payment",
                                      "no-caps": "",
                                      label: _ctx.$t('add_payment')
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_q_tab_panels, {
                              modelValue: _ctx.accounts_tab,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.accounts_tab) = $event)),
                              animated: "",
                              class: "full-height bg-white",
                              style: {"overflow":"hidden"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tab_panel, {
                                  name: "account_selector",
                                  class: "bg-white full-height q-pa-xs",
                                  style: {"overflow":"hidden"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_aux_selector, {
                                      class: "movement-accounts-selector",
                                      "model-type": !_ctx.existingMovementId ? 18 : 26,
                                      "set-id": _ctx.existingMovementId,
                                      "input-index": 0,
                                      "hide-close-button": true,
                                      modelValue: _ctx.tmp_selected_account,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tmp_selected_account) = $event)),
                                      "allow-multiple": false,
                                      onSelectorClosed: _cache[21] || (_cache[21] = ($event: any) => (
                          _ctx.$refs.acc_menu && _ctx.$refs.acc_menu.hide()
                        ))
                                    }, null, 8, ["model-type", "set-id", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isIncome)
                                  ? (_openBlock(), _createBlock(_component_q_tab_panel, {
                                      key: 0,
                                      name: "new_payment",
                                      class: "bg-white full-height q-pa-none q-pb-sm",
                                      style: {"overflow":"hidden"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_payment_create_component, {
                                          modelValue: _ctx.newPayment,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newPayment) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createElementVNode("div", _hoisted_26, [
                                          _createVNode(_component_q_btn, {
                                            "no-caps": "",
                                            label: _ctx.$t('attach'),
                                            color: "primary",
                                            disable: 
                            !_ctx.newPayment.paymentNumber.length ||
                            _ctx.newPayment.paymentAmount <= 0 ||
                            !_ctx.newPayment.currencyName.length
                          ,
                                            onClick: _withModifiers(_ctx.addNewPayment, ["stop"])
                                          }, null, 8, ["label", "disable", "onClick"])
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !_ctx.isEditMode || _ctx.isEditing]
                    ])
                  ]),
                  (_ctx.entity_store.accounts?.length)
                    ? (_openBlock(), _createBlock(_component_connections_table_html, {
                        key: 0,
                        modelValue: _ctx.entity_store.accounts,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.entity_store.accounts) = $event)),
                        onRemoveItem: _ctx.removeConnection,
                        "check-sums": false,
                        "show-sums": _ctx.isIncome,
                        "hide-remove-btn": _ctx.isEditMode && !_ctx.isEditing,
                        "show-lock-status": true,
                        "read-only": _ctx.readOnly
                      }, null, 8, ["modelValue", "onRemoveItem", "show-sums", "hide-remove-btn", "read-only"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.tmp_payments?.length && _ctx.isIncome)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('payments')) + ":", 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_connections_table_html, {
                          "model-value": _ctx.tmp_payments,
                          "check-sums": false,
                          "show-sums": false,
                          onRemoveItem: _ctx.removePayment,
                          "hide-remove-btn": false,
                          "read-only": _ctx.readOnly
                        }, null, 8, ["model-value", "onRemoveItem", "read-only"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_ctx.$t('files')) + " ", 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("input", {
                        ref: "fileInputStorage",
                        type: "file",
                        multiple: "",
                        hidden: "",
                        onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.attachFileForMovementAdd && _ctx.attachFileForMovementAdd(...args)))
                      }, null, 544),
                      (!_ctx.isEditMode || _ctx.isEditing)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: _ctx.fileIconName,
                            size: "xs",
                            color: "accent",
                            class: "pointer hover-green",
                            title: _ctx.$t('attach_files'),
                            onClick: _ctx.chooseAndUploadFile
                          }, null, 8, ["name", "title", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedFiles, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "file-item"
                      }, [
                        _createElementVNode("span", {
                          class: "file_container",
                          title: _ctx.$t('upload_file'),
                          onClick: _withModifiers(($event: any) => (_ctx.DownloadFile(file, $event)), ["stop"])
                        }, _toDisplayString(file.Name), 9, _hoisted_34),
                        (!_ctx.isEditMode || _ctx.isEditing)
                          ? (_openBlock(), _createBlock(_component_app_icon, {
                              key: 0,
                              name: "delete-outline",
                              width: "18px",
                              color: "#979797",
                              "hover-color": "#499259",
                              cursor: "pointer",
                              title: _ctx.$t('remove'),
                              onClick: ($event: any) => (_ctx.deleFileFromMovementAdd(file.Id))
                            }, null, 8, ["title", "onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingFiles, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.tempId,
                        class: "file-item"
                      }, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(item.name) + " (" + _toDisplayString(_ctx.$t('prepared')) + ") ", 1),
                        _createVNode(_component_app_icon, {
                          name: "delete-outline",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          title: _ctx.$t('remove'),
                          onClick: ($event: any) => (_ctx.removePending(item.tempId))
                        }, null, 8, ["title", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('details_type')) + ":", 1),
                        (_ctx.canEditMovementComment && (!_ctx.isEditMode || _ctx.isEditing))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "comment-tpl-trigger q-ml-sm",
                              style: {"align-self":"start"},
                              onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_app_icon, {
                                name: "comment-template",
                                width: "18px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                title: _ctx.$t('info_templates')
                              }, null, 8, ["title"]),
                              (_ctx.canEditMovementComment && (!_ctx.isEditMode || _ctx.isEditing))
                                ? (_openBlock(), _createBlock(_component_q_menu, {
                                    key: 0,
                                    "max-height": "1300px",
                                    ref: "comment_template_menu",
                                    anchor: "center right",
                                    self: "center left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_aux_selector, {
                                        "model-type": 25,
                                        "input-index": 0,
                                        "allow-multiple": false,
                                        "allow-free-input": true,
                                        onDeleteItem: _ctx.deleteCommentTemplate,
                                        modelValue: _ctx.comment_templates,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.comment_templates) = $event)),
                                        onInputValue: _cache[29] || (_cache[29] = 
                          (val) => {
                            _ctx.addCommentTemplate(val);
                          }
                        ),
                                        onSelectorClosed: _cache[30] || (_cache[30] = ($event: any) => (
                          _ctx.$refs.comment_template_menu &&
                            _ctx.$refs.comment_template_menu.hide()
                        ))
                                      }, null, 8, ["onDeleteItem", "modelValue"])
                                    ]),
                                    _: 1
                                  }, 512))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isEditMode && !_ctx.isEditing && _ctx.existingMovementComment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.existingMovementComment), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.isEditMode || _ctx.isEditing)
                        ? (_openBlock(), _createBlock(_component_native_input, {
                            key: 1,
                            ref: "comment_field",
                            style: {"width":"-webkit-fill-available"},
                            "show-border": _ctx.canEditMovementComment && (!_ctx.isEditMode || _ctx.isEditing),
                            "model-value": _ctx.currentCommentValue,
                            "edit-on-click": true,
                            "disabled-field": !_ctx.canEditMovementComment || (_ctx.isEditMode && !_ctx.isEditing),
                            "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                            onClick: _ctx.onNativeInputClick,
                            onBlur: _ctx.onCommentBlur,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = 
                    (newname) => {
                      _ctx.setCommentValue(newname);
                    }
                  )
                          }, null, 8, ["show-border", "model-value", "disabled-field", "onUpdate:caretPosition", "onClick", "onBlur"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        (
                      _ctx.isIncome &&
                      !(_ctx.canCreateWithoutBills && _ctx.accountsTotal === 0)
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.$t('amount_by_invoices')) + ":  ", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('amount_by_positions')) + ": ", 1),
                        (
                      _ctx.isIncome &&
                      !(_ctx.canCreateWithoutBills && _ctx.accountsTotal === 0)
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, " (" + _toDisplayString(_ctx.$t('must_be_equal')) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        (
                      _ctx.isIncome &&
                      !(_ctx.canCreateWithoutBills && _ctx.accountsTotal === 0)
                    )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([
                      'summary__label',
                      { 'green-text': _ctx.sumsEqualForCreation },
                    ])
                            }, _toDisplayString(_ctx.money(_ctx.accountsTotal)), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass([
                      'summary__label',
                      {
                        'green-text':
                          _ctx.isIncome &&
                          !(_ctx.canCreateWithoutBills && _ctx.accountsTotal === 0) &&
                          _ctx.sumsEqualForCreation,
                      },
                    ])
                        }, _toDisplayString(_ctx.money(_ctx.positionsTotal)), 3)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.isEditMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('add_position')), 1),
                      _createElementVNode("div", _hoisted_50, [
                        (_ctx.currentPosId > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_app_icon, {
                                class: "q-mr-xs add-pos-info",
                                name: "info-circle-outline",
                                width: "18px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                title: _ctx.$t('info'),
                                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showPosInfoMode = true))
                              }, null, 8, ["title"]),
                              _createVNode(_component_q_dialog, {
                                modelValue: _ctx.showPosInfoMode,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showPosInfoMode) = $event)),
                                "no-shake": "",
                                "full-width": !_ctx.isMobile,
                                maximized: _ctx.isMobile
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_item_addition_component, {
                                    "existing-position-id": _ctx.currentPosId,
                                    onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showPosInfoMode = false))
                                  }, null, 8, ["existing-position-id"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "full-width", "maximized"])
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_51, [
                          _withDirectives(_createElementVNode("div", _hoisted_52, "•", 512), [
                            [_vShow, _ctx.currentPosId]
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            (_ctx.contextParameterContainerEl)
                              ? (_openBlock(), _createElementBlock("table", _hoisted_54, [
                                  _createVNode(_component_parameter_inline, {
                                    "is-root": true,
                                    ref: "template_edit",
                                    "use-vendor-code": true,
                                    "use-storage-field": _ctx.isIncome,
                                    id: 'move-dialog',
                                    editable: true,
                                    "storage-for-hint": _ctx.getStorageFilter,
                                    modelValue: _ctx.parameters,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.parameters) = $event)),
                                    "token-styles": _ctx.tokenStyles,
                                    onStoragePosChange: _ctx.onPosChange,
                                    "is-table": true,
                                    "create-mode": true,
                                    "context-trigger": _ctx.contextParameterContainerEl
                                  }, null, 8, ["use-storage-field", "storage-for-hint", "modelValue", "token-styles", "onStoragePosChange", "context-trigger"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 512)
                        ]),
                        (!_ctx.isPositionInputEmpty)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              dense: "",
                              flat: "",
                              color: "accent",
                              size: "14px",
                              icon: _ctx.clearIconName,
                              class: "q-pa-none q-mx-sm",
                              onClick: _ctx.resetTemplate
                            }, null, 8, ["icon", "onClick"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(
                  'row no-wrap cursor-pointer q-pa-none q-ml-sm q-mr-xl q-mt-xs ' +
                  (_ctx.additionEnabled ? 'cursor-pointer' : 'disabled')
                ),
                          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.addPositionClick && _ctx.addPositionClick(...args)))
                        }, [
                          (_ctx.currentPosId <= 0)
                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                key: 0,
                                name: _ctx.newIconName,
                                class: "cursor-pointer q-mr-xs",
                                size: "20px",
                                color: "grey-6",
                                title: ""
                              }, null, 8, ["name"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_icon, {
                            name: _ctx.addPositionIconName,
                            class: "cursor-pointer",
                            size: "20px",
                            color: "grey-6",
                            title: ""
                          }, null, 8, ["name"]),
                          (_ctx.addButtonHint)
                            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                key: 1,
                                delay: 300,
                                anchor: "top middle",
                                self: "center middle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.addButtonHint), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.theModel.positions?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('action_positions')) + ":", 1),
                      _createVNode(_component_positions_table_html, {
                        modelValue: _ctx.theModel.positions,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.theModel.positions) = $event)),
                        onRecalc: _ctx.recalcTotals,
                        "create-type": _ctx.createCompoundType,
                        "current-storage": _ctx.theModel.from,
                        "hide-remove-btn": _ctx.isEditMode,
                        "can-edit": !_ctx.isEditMode || _ctx.isEditing,
                        "can-edit-quantity": !_ctx.isEditMode,
                        "read-only": _ctx.readOnly
                      }, null, 8, ["modelValue", "onRecalc", "create-type", "current-storage", "hide-remove-btn", "can-edit", "can-edit-quantity", "read-only"])
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.isStorageConfirmed]
              ])
            ]))
      ]),
      ((!_ctx.isEditMode || _ctx.isIncome) && !_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                label: 
            !_ctx.isEditMode
            ? _ctx.$t('create_short')
            : (_ctx.isEditing ? (_ctx.isLoading ? _ctx.$t('loading_short') : _ctx.$t('save')) : _ctx.$t('edit'))
          ,
                color: "primary",
                unelevated: "",
                disable: 
            _ctx.isEditMode && ((_ctx.isIncome && !_ctx.canEditIncome) || (_ctx.isEditing && !_ctx.creationAllowed)) ||
            !_ctx.isEditMode && !_ctx.creationAllowed ||
            (!_ctx.isEditMode || _ctx.isEditing) && !_ctx.allEntitiesLockedByUs ||
            _ctx.isLoading
          ,
                onClick: _withModifiers(_ctx.actionButtonClick, ["stop"])
              }, {
                default: _withCtx(() => [
                  (_ctx.actionButtonDisableReason)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 0,
                        delay: 300,
                        anchor: "top middle",
                        self: "center middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.actionButtonDisableReason), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label", "disable", "onClick"]),
              _createVNode(_component_q_btn, {
                label: _ctx.$t('cancel_short'),
                "no-caps": "",
                flat: "",
                onClick: _ctx.handleEsc
              }, null, 8, ["label", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onKeydown"]))
}